<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-activiti__model">
      <el-form :inline="true"
               :model="dataForm"
               label-position="top"
               @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('model.name')">
              <el-input v-model="dataForm.name"
                        type="text"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('model.key')">
              <el-input v-model="dataForm.key"
                        type="text"
                        clearable>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4"
                  class="fr">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         @click="getDataList">{{$t('query')}}</el-button>
              <el-button style="margin-bottom: 7px"
                         class="el-back M-search M-margin-l"
                         type="info"
                         @click="reset()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div class="row-mar-l">
          <el-button type="primary"
                     @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </div>
      </el-form>
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%;">
        <el-table-column prop="name"
                         :label="$t('model.name')"
                         header-align="center"
                         align="left"></el-table-column>
        <el-table-column prop="key"
                         :label="$t('model.key')"
                         header-align="center"
                         align="left"></el-table-column>
        <el-table-column prop="version"
                         :label="$t('model.version')"
                         header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="createTime"
                         :label="$t('model.createTime')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <el-table-column prop="lastUpdateTime"
                         :label="$t('model.lastUpdateTime')"
                         header-align="center"
                         align="center"
                         width="180"></el-table-column>
        <el-table-column :label="$t('handle')"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="gotoView('design', scope.row.id)"><a :href="getModelerURL(scope.row.id)"
                     target="_blank">{{ $t('model.design') }}</a></el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('deploy', scope.row.id)">{{ $t('model.deploy') }}</el-dropdown-item>
                <el-dropdown-item @click.native="gotoView('export', scope.row.id)"><a :href="getExportURL(scope.row.id)"
                     target="_blank">{{ $t('export') }}</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible"
                     ref="addOrUpdate"
                     @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-activiti'
import AddOrUpdate from './model-add-or-update'
import qs from 'qs'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/act/model/list',
        getDataListIsPage: true,
        deleteURL: '/act/model/delete',
        exportURL: '/act/model/export'
      },
      dataForm: {
        name: '',
        key: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  methods: {
    // 删除
    // deleteHandle (id) {
    //   this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
    //     confirmButtonText: this.$t('confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     type: 'warning'
    //   }).then(() => {
    //     this.$request.deleteAct(
    //       this.mixinViewModuleOptions.deleteURL,
    //       {
    //         id: id
    //       }
    //     ).then((res) => {
    //       this.$message({
    //         message: this.$t('prompt.success'),
    //         type: 'success',
    //         duration: 500,
    //         onClose: () => {
    //           this.getDataList()
    //         }
    //       })
    //     }).catch(() => {})
    //   }).catch(() => {})
    // },
    // 操作列下拉选项
    gotoView(type, id) {
      if (type === 'design') {
        this.getModelerURL(id)
      } else if (type === 'deploy') {
        this.deployHandle(id)
      } else if (type === 'export') {
        this.getExportURL(id)
      } else if (type === 'delete') {
        // this.deleteHandle(id)
      }
    },
    // 获取在线设计url地址
    getModelerURL(id) {
      var params = qs.stringify({
        'token': this.getStorage(this.GLOBAL.TOKEN),
        'modelId': id
      })
      return `${window.SITE_CONFIG['actApiURL']}/modeler.html?${params}`
    },
    // 获取导出url地址
    getExportURL(id) {
      var params = qs.stringify({
        'token': this.getStorage(this.GLOBAL.TOKEN)
      })
      return `${window.SITE_CONFIG['actApiURL']}/act/model/export/${id}?${params}`
    },
    // 部署
    deployHandle(id) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('model.deploy') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        this.$request.postAct(`/act/model/deploy/${id}`).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
